import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function UserData() {
    const [userData, setUserData] = useState([]);
    const [userDataAgegroup, setUserDataAgegroup] = useState([]);
    const baseURL = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`https://ndl.education.gov.in/api/users_by_day`, {
                    headers: {
                        accept: 'application/json',
                    },
                });

                // Use the response data directly
                const result = response.data;
                console.log('Response body:', result);
                setUserData(result);  // Update the state with fetched data

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [baseURL]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`https://ndl.education.gov.in/api/users_agegroup_count`, {
                    headers: {
                        accept: 'application/json',
                    },
                });

                // Use the response data directly
                const result = response.data;
                console.log('Response body:', result);
                setUserDataAgegroup(result);  // Update the state with fetched data

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [baseURL]);

    return (
        <>

            <section className='user_data my-5'>
                <div className='container'>
                    <div className='row'>
                        <h1 className='title-heading text-center mb-4'>Rashtriya e-Pustakalaya –Status Update</h1>
                        <div className='col-md-12 table-scroll'>
                            <table className='table-list table-responsive'>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Users</th>
                                        <th>Previous day Downloads</th>
                                        <th>School Activities/Camp</th>
                                    </tr>

                                </thead>
                                <tbody>

                                    {userData.slice(-10).map((data, index) => (
                                        <tr key={index}>
                                            <td>{data.day}</td>
                                            <td>{data.count} users</td>
                                            <td>--</td>
                                            <td>--</td>
                                        </tr>
                                    ))}


                                </tbody>
                            </table>
                        </div>
                        <h2 className='title-heading my-4'>Summary of Rashtriya e-Pustakalaya on Android and iOS</h2>
                        <ul>
                            <li>Android Rati ng (as on 17 Dec 2024)-3.7 out of 5 (808 User Reviews)</li>
                            <li>Total users using iOS (as on 15 Dec 2024)-9,821</li>
                            <li>Total number of devices with Rashtriya e-Pustakalaya installed (As on 14 Dec 2024)- 63,217</li>
                        </ul>
                        <h2 className='title-heading my-4'>User Trends (Android)</h2>
                        <div className='col-md-12 table-scroll'>
                            <table className='table-list table-responsive'>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>

                                        <th>Date</th>
                                        <th>New User
                                            (android+
                                            iOS)</th>
                                        <th>No. of devices with
                                            installed Rep applicati on
                                            (android)*</th>

                                        <th>New
                                            installati ons
                                            (android)#</th>
                                        <th>Devices
                                            Uninstallati on
                                            (android)$</th>

                                    </tr>

                                </thead>
                                <tbody>

                                    {userData.slice(-10).map((data, index) => (
                                        <tr key={index}>
                                            <td>1</td>
                                            <td>New User
                                                (android+
                                                iOS)</td>
                                            <td>No. of devices with
                                                installed Rep applicati on
                                                (android)*</td>
                                            <td>{data.day}</td>
                                            <td>{data.count} users</td>
                                            <td>--</td>

                                        </tr>
                                    ))}


                                </tbody>
                            </table>
                        </div>
                        <h2 className='title-heading my-4'>User Trends (iOS)</h2>
                        <div className='col-md-12 table-scroll'>
                            <table className='table-list table-responsive'>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Users</th>
                                        <th>Number of users</th>

                                    </tr>

                                </thead>
                                <tbody>

                                    {userData.slice(-10).map((data, index) => (
                                        <tr key={index}>
                                            <td>1</td>
                                            <td>{data.day}</td>
                                            <td>Number of users</td>
                                        </tr>
                                    ))}


                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>

            <section className=' user_data mb-5'>
                <div className='container'>
                    <div className='row'>
                        <h2 className='title-heading my-4'>User By Age Group</h2>
                        <div className='col-md-12 table-scroll'>
                            <table className='table-list table-responsive'>
                                <thead>
                                    <tr>
                                        <th>Age Group</th>
                                        <th>Count</th>
                                    </tr>

                                </thead>
                                <tbody>

                                    {userDataAgegroup.map((data, index) => (
                                        <tr key={index}>
                                            <td>{data.agegroup_name}</td>
                                            <td>{data.user_count}</td>
                                        </tr>
                                    ))}


                                </tbody>
                            </table>
                        </div>
                       
                    </div>
                </div>
            </section>

        </>
    );
}
